import { TagsSelect } from "@/components/form/tags-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a list of tag ids** (`string[]`). */
export type TagsFieldProps = PickerFieldProps<string[]>;

export const TagsField = makePickerField<string[]>({
  name: "TagsField",
  control: TagsSelect,
  popout: true,
});
